import { render, staticRenderFns } from "./ConsultationFeedback.vue?vue&type=template&id=1a0e64db&scoped=true"
import script from "./ConsultationFeedback.vue?vue&type=script&lang=js"
export * from "./ConsultationFeedback.vue?vue&type=script&lang=js"
import style0 from "./ConsultationFeedback.vue?vue&type=style&index=0&id=1a0e64db&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a0e64db",
  null
  
)

export default component.exports